export default __webpack_public_path__ + "static/media/solution_51.c8b6430a.svg";